import { Select, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const HeaderContainer = styled(Stack)(() => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '1rem',
  marginBottom: '1.5rem',
  minWidth: 0,
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '1rem',
  color: theme.palette.grey[900],
}));

export const RightSection = styled(Stack)(() => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '0.62rem',
}));

export const PeriodSelect = styled(Select)(({ theme }) => ({
  minWidth: '8rem',
  borderRadius: '0.5rem',
  border: '1px solid rgba(0, 0, 0, 0.15)',
  padding: '0.25rem 0.75rem',
  fontSize: '0.75rem',
  fontWeight: 400,
  lineHeight: '160%',
  color: theme.palette.grey[800],

  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.grey[300],
  },

  '& fieldset': {
    border: 'none !important',
  },
}));

export const LeftSection = styled(Stack)(() => ({
  flex: 1,
  minWidth: 0,
}));
